import React from 'react';

import {
  activityTemplates,
  routeDirectory
} from 'modules';
import {
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import { TabBar } from 'iron-forge-react-modules';
import { Paper } from '@mui/material';
import * as PendingWritesTab from './PendingWritesTab/PendingWritesTab';
import * as ValidationErrorsTab from './ValidationErrorsTab/ValidationErrorsTab';
import * as OrderListTable from './OrderListTable/OrderListTable';
import { ValidationState } from 'generated/graphql';



type ITabId = 'pendingWrites' | 'validationErrors' | 'valid' | 'invalid' | 'invalidArchived';

export const OrderManagementActivity: React.FC = () => {
  const params = useParams<{ tabId: ITabId; }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const storeId = searchParams.get('storeId');
  const writeRequestId = searchParams.get('writeRequestId');

  const handleSelectTab = React.useCallback(
    (tabId: ITabId) => {
      const params = new URLSearchParams();
      if (storeId) {
        params.set('storeId', storeId);
      }
      if (writeRequestId && tabId === 'validationErrors') {
        params.set('writeRequestId', writeRequestId);
      }
      const search = params.toString();
      navigate(routeDirectory.admin.orderManagement.path(tabId) + (search ? `?${search}` : ''), { replace: true });
    },
    [navigate, storeId, writeRequestId]
  );

  const currentTabId = params.tabId ?? 'pendingWrites';

  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <TabBar.FC
        tabId={currentTabId}
        tabs={[
          {
            id: 'pendingWrites',
            label: "Pending Writes"
          },
          {
            id: 'validationErrors',
            label: "Validation Errors"
          },
          {
            id: 'valid',
            label: "Cached Valid Orders"
          },
          {
            id: 'invalid',
            label: "Cached Invalid Orders"
          },
          {
            id: 'invalidArchived',
            label: "Archived Orders"
          }
        ]}
        onSelectTab={tabId => handleSelectTab(tabId as ITabId)} />

      <Paper>
        {currentTabId === 'pendingWrites' && (
          <PendingWritesTab.FC />
        )}

        {currentTabId === 'validationErrors' && (
          <ValidationErrorsTab.FC />
        )}

        {(currentTabId === 'valid' || currentTabId === 'invalid' || currentTabId === 'invalidArchived') && (
          <OrderListTable.FC
            key={`${currentTabId}-${storeId}`}
            storeId={storeId}
            validationState={currentTabId as ValidationState}
            onSelectTab={tabId => {
              const params = new URLSearchParams();
              if (storeId) {
                params.set('storeId', storeId);
              }
              const search = params.toString();
              navigate(routeDirectory.admin.orderManagement.path(tabId as 'valid' | 'invalid' | 'invalidArchived', undefined, storeId) + (search ? `?${search}` : ''), { replace: true });
            }} />
        )}
      </Paper>
    </activityTemplates.AdminActivityTemplate.FC>
  );
};

